import { Button, Input, Form } from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { useLocalization } from "@i18n";
import { ClientFilterData } from "../../types";
import { Filter } from "lucide-react";

interface ClientsFilterProps {
  onFilter: (data: ClientFilterData) => void;
  onClear: () => void;
  initialFilters?: Partial<ClientFilterData>;
}

export const ClientsFilter = ({
  onFilter,
  onClear,
  initialFilters,
}: ClientsFilterProps) => {
  const { translate } = useLocalization();

  const form = useForm<ClientFilterData>({
    defaultValues: {
      name: initialFilters?.name ?? "",
      fantasyName: initialFilters?.fantasyName ?? "",
      cnpj: initialFilters?.cnpj ?? "",
      responsibleName: initialFilters?.responsibleName ?? "",
    },
  });

  const handleFilter = (data: ClientFilterData) => {
    onFilter(data);
  };

  const handleClear = () => {
    form.reset();
    onClear();
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleFilter)}>
        <div className="flex flex-column gap-5">
          <Input
            control={form.control}
            label={`${translate("management.clients.form.label.client")}:`}
            name="name"
            type="text"
            placeholder={translate(
              "management.clients.form.placeholder.filterClient",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("management.clients.form.label.tradeName")}:`}
            name="fantasyName"
            type="text"
            placeholder={translate(
              "management.clients.form.placeholder.filterTradeName",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("management.clients.form.label.cnpj")}:`}
            name="cnpj"
            type="text"
            placeholder={translate(
              "management.clients.form.placeholder.filterCnpj",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("management.clients.form.label.responsible")}:`}
            name="responsibleName"
            type="text"
            placeholder={translate(
              "management.clients.form.placeholder.filterResponsible",
            )}
          />
        </div>
        <div className="flex justify-end mb-4 gap-4">
          <Button type="button" variant="secondary" onClick={handleClear}>
            {translate("management.clients.button.clearFilters")}
          </Button>
          <Button type="submit" iconLeft={<Filter fill="currentColor" />}>
            {translate("management.clients.button.filter")}
          </Button>
        </div>
      </form>
    </Form>
  );
};
